var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import "./index.css";
let EventTitleFlex = class EventTitleFlex extends Vue {
  render() {
    const h = arguments[0];
    return h("div", [h("div", {
      "class": "ucd-eventTitleFlex",
      "on": {
        "contextmenu": ev => this.$emit('contextmenu', ev),
        "mousedown": ev => this.$emit('mousedown', ev)
      }
    }, [this.$slots.handle, h("div", {
      "slot": "handle",
      "class": "ucd-sfeStep-handle"
    }), this.$slots.toggle, this.$slots.title]), this.$slots.default]);
  }
};
EventTitleFlex = __decorate([Component({
  name: 'EventTitleFlex'
})
/**
 * 提供handle toggle title 3个插槽重构原本的ucd-sfeStep grid的toggle title区域
 * */], EventTitleFlex);
export { EventTitleFlex };
//# sourceMappingURL=EventTitleFlex.js.map
